import { buildMissionsClassifierValueProviders } from './classifier-value-providers/buildMissionsClassifierValueProviders';
import { valueProviders } from './classifier-value-providers/valueProviders';
export function buildMissionsValueProviders(appName, userState) {
    const providers = [];
    providers.push(...buildMissionsClassifierValueProviders(appName, userState));
    providers.push(...valueProviders);
    return providers;
}
